export enum DesignStyle {
    SITE_THEME = 'site-theme',
    BASIC = 'basic',
}

export interface FeatureMetadata {
    isNativeBookingAvailable: boolean;
    isNativeBookingPublishingAvailable: boolean;
    isPaidNativeBookingAvailable: boolean;
}

export interface BookerContextType extends FeatureMetadata {
    eventSlug: string;
    teamId: number;
    userName: string;
    rescheduleUid?: string | null;
    cancelBookingId?: string | null;
    widgetId: string;
    designStyle: DesignStyle;
    language: string;
    apiUrl: string;
    clientId: string;
}

export interface Booking {
    title: string;
    userPrimaryEmail: string;
    startTime: string;
    user: {
        name: string;
    };
    videoCallUrl?: string;
    location?: string;
    uid: string;
    endTime: Date;
    attendees: Array<{
        name: string;
        email: string;
    }>;
    status: BookingStatus;
}

export enum UrlAction {
    RESCHEDULE = 'reschedule',
    CANCEL = 'cancel',
}

export enum BookingStatus {
    CANCELLED = 'CANCELLED',
    PENDING = 'PENDING',
    RESCHEDULED = 'RESCHEDULED',
    ACCEPTED = 'ACCEPTED',
    REJECTED = 'REJECTED',
}
